export default {
    init() {
        toggleVideos();
    }
}

function toggleVideos() {
    let videos = document.querySelectorAll(".case-study-card video");

    if (videos.length > 0) {
        videos.forEach(function (video) {
            video.addEventListener("mouseover", function () {
                video.play();
            });

            video.addEventListener("mouseout", function () {
                video.pause();
            });
        });
    }
}
